<template>
  <v-app>
    <AppBar />
    <v-main>
      <!-- Hero con carrusel -->
      <v-carousel height="80vh" show-arrows="hover" cycle hide-delimiters>
        <div class="gradient-bg"></div>
        <!-- Slide 1: Básico -->
        <v-carousel-item>
          <v-img
            :src="require('@/assets/curso-java.png')"
            cover
            height="100%"
            width="100%"
          >
            <!-- Overlay degradado -->
            <div class="gradient-overlay"></div>

            <!-- Contenido encima -->
            <div class="overlay-content">
              <h2 class="display-2 font-weight-bold titulo-stroke">
                CURSO ESPECIALISTA EN JAVA
              </h2>
              <p class="white--text">Java desde cero hasta experto</p>
              <v-btn color="orange darken-2" dark @click="whatsappLink('Java')"
                >INSCRIBIRME</v-btn
              >
            </div>
          </v-img>
        </v-carousel-item>

        <!-- Slide 2: Intermedio -->
        <v-carousel-item :src="require('@/assets/asp.jpg')" cover>
          <div class="overlay">
            <v-row class="fill-height" align="center" justify="center">
              <v-col cols="12" class="text-center">
                <h1 class="display-2 font-weight-bold titulo-stroke">
                  Domina .NET en tus proyectos
                </h1>

                <div class="headline font-weight-bold mt-4 titulo-strokeNet">
                  <span style="color: #7e57c2"
                    >Aprende programación orientada a objetos</span
                  >
                  -
                  <span style="color: #ff6f00">con ejemplos reales</span>
                </div>

                <v-btn
                  color="deep-purple"
                  large
                  class="mt-6"
                  @click="whatsappLink('.Net')"
                  >INSCRIBIRME</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-carousel-item>

        <!-- Slide 3: Experto -->
        <v-carousel-item :src="require('@/assets/python.jpg')" cover>
          <div class="overlay">
            <v-row class="fill-height" align="center" justify="center">
              <v-col cols="12" md="8" class="text-white text-center">
                <h1 class="display-2 font-weight-bold titulo-stroke">
                  Domina Python y trabaja ya!!
                </h1>
                <div class="headline font-weight-bold mt-4 titulo-strokPython">
                  <span style="color: #7e57c2">De lo básico</span> -
                  <span style="color: #ff6f00">a nivel experto</span>
                </div>
                <v-btn color="green" large class="mt-6" @click="whatsappLink('Python')"
                  >INSCRIBIRME</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-carousel-item>
      </v-carousel>

      <!-- Tu contenido después -->
      <router-view />
    </v-main>
    <FooterSection />
    <SocialSidebar />
    <WhatsappFloat />
  </v-app>
</template>
<script>
export default {
  name: "PageInicial",
  data: () => ({
    showNotice: false,
    whatsappNumber: "+51928180748",
  }),
  methods: {
    whatsappLink(n) {
      const message = "Hola, quiero inscribirme en el Curso de " + n;
      const url = `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(
        message
      )}`;
      window.open(url, "_blank");
    },
  },
};
</script>
<style scoped>
.carousel-image {
  background: linear-gradient(to right, #0d1b2a, #1b263b);
}

/* Overlay oscuro para texto encima */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35); /* sombra ligera */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1;
}

.overlay h1,
.overlay .headline,
.overlay .v-btn {
  z-index: 2;
}
.white--text {
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.9);
}
.gradient-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, #0d1b2a, #1b263b); /* colores del banner */
  z-index: 0;
}
.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(0, 30, 60, 0.9),
    /* azul oscuro casi opaco */ rgba(3, 24, 45, 0.7),
    /* más claro en medio */ rgba(1, 21, 41, 0.3) /* se desvanece al final */
  );
  z-index: 1;
}
.overlay-content {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-70%);
  z-index: 2;
}
.titulo-stroke {
  text-shadow: 2px 2px 6px rgba(241, 234, 234, 0.8); /* sombra oscura */
  -webkit-text-stroke: 1px rgb(201, 194, 194);
}
.titulo-strokeNet {
  text-shadow: 2px 2px 6px rgba(5, 5, 5, 0.8); /* sombra oscura */
  -webkit-text-stroke: 1px rgb(33, 28, 28);
}
.titulo-strokPython {
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.8); /* sombra oscura */
  -webkit-text-stroke: 1px rgb(17, 16, 16);
}
</style>
